export default __webpack_public_path__ + "static/media/arrow-down-circle.ec47babe.svg";